import { createReduxModule } from "hooks-for-redux";
const initialState = {
  user: null,
};

const [
  useUserProfile,
  { setUserProfile, doUpdateRelationship },
  userProfileStore,
] = createReduxModule("userProfile", initialState, {
  setUserProfile: (state, user) => ({ ...state, user }),
  doUpdateRelationship: (state, status) => ({
    ...state,
    user: { ...state.user, status },
  }),
});

export {
  useUserProfile,
  setUserProfile,
  doUpdateRelationship,
  userProfileStore,
};
